import AssessmentPreview from "pages/ManagementPage/AssessmentPreview/AssessmentPreview";

export default AssessmentPreview;
